import React, { useState } from "react";
import RewardType from "./RewardType";
import SurveyStatus from "./SurveyStatus";
import TransactionType from "./TransactionType";
import Reward from "./Reward";
import Transaction from "./Transaction";


const TransactionUtils = () => {
  const [activeComponent, setActiveComponent] = useState("Reward Type")
  // Array with tab names and corresponding components
  const tabs = [
    // { name: "Reward Type", component: <Reward /> },

    { name: "Reward Type", component:  <RewardType /> },
    { name: "Survey Status Type", component: <SurveyStatus />},
    { name: "Redeem Type", component: <TransactionType />},

    // { name: "Redeem List", component: <Transaction />},
    
  ];

  // Find the active tab and its component
  const renderComponent = () => {
    const activeTab = tabs.find(tab => tab.name === activeComponent);
    return activeTab ? activeTab.component : null;
  };

  const changeActiveComponent = (name)=>{
    setActiveComponent(name)
  }

  return (
    <div className="min-h-screen flex flex-col items-center p-4 pt-2">
      <div className="flex space-x-4 mb-6 max-w-100 flex-wrap gap-2">
        {tabs.map(({ name }) => (
          <button
            key={name}
            className={`px-4 py-2 rounded-lg text-sm border-b-2 ${
              activeComponent === name
                ? "activeBtn text-white"
                : "bg-neutral-50 text-gray-800 hover:bg-blue-100"
            }`}
            onClick={() => {changeActiveComponent(name)}}
          >
            {name}
          </button>
        ))}
      </div>

      {renderComponent()}
    </div>
  );
};

export default TransactionUtils;
